import React from 'react';
export default function Pagination({ total, page, perPage, onPage }) {
  const totalPages = Math.ceil(total / perPage);
  if (totalPages <= 1) return null;
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 2) {
      if (pages.length && pages[pages.length-1] !== '...' && i > pages[pages.length-1]+1) pages.push('...');
      pages.push(i);
    }
  }
  const btn = { padding:'5px 12px', fontSize:13, borderRadius:6,
                border:'1px solid #ddd', cursor:'pointer', background:'#fff' };
  return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',
                 gap:5,padding:'16px 0',flexWrap:'wrap',direction:'ltr'}}>
      <button style={{...btn,background:page===1?'#f5f5f5':'#fff'}}
        onClick={()=>onPage(page-1)} disabled={page===1}>{'<'}</button>
      {pages.map((n,i) => typeof n==='number'
        ? <button key={n} onClick={()=>onPage(n)} style={{...btn,
            fontWeight:page===n?700:400,
            background:page===n?'var(--primary,#c0392b)':'#fff',
            color:page===n?'#fff':'#333'}}>{n}</button>
        : <span key={'d'+i} style={{color:'#bbb',padding:'0 2px'}}>…</span>
      )}
      <button style={{...btn,background:page===totalPages?'#f5f5f5':'#fff'}}
        onClick={()=>onPage(page+1)} disabled={page===totalPages}>{'>'}</button>
      <span style={{fontSize:12,color:'#888',marginRight:6}}>
        {(page-1)*perPage+1}–{Math.min(page*perPage,total)} / {total}
      </span>
    </div>
  );
}
